var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "#1e284d",
  viewBox: "0 0 12.138 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.816 10.777-8.9 8.9a1.1 1.1 0 0 1-1.554 0L.324 18.639a1.1 1.1 0 0 1 0-1.553l7.054-7.087L.324 2.912a1.1 1.1 0 0 1 0-1.553L1.361.322a1.1 1.1 0 0 1 1.554 0l8.9 8.9a1.1 1.1 0 0 1 .001 1.555",
  className: "chevron-left_svg__a"
})));
export default SvgChevronLeft;